import React, { useContext } from "react";

import styles from "./styles/ErrorButtons.module.css";

import { useTranslation } from "react-i18next";
import NavButton from "../ui/navbutton/NavButton";
import DataContext from "../../context/DataContext";
import Button from "../ui/button/Button";

/**
 * The ErrorButtons component
 * Handles the error buttons and the send feedback email
 */
export const ErrorButtons = ({ isMinorError }) => {
    const { t } = useTranslation();
    const { homePath } = useContext(DataContext);

    return (
        <section
            className={`${styles.result_buttons_container} flex-container`}
        >
            {isMinorError ? (
                <div>
                    <NavButton body={t(`back to search`)} link={homePath} />
                </div>
            ) : (
                <div>
                    <NavButton
                        body={t("schweers website")}
                        link={"https://www.schweers.com"}
                    />
                </div>
            )}
        </section>
    );
};
